<template>
    <section>
        <!-- Alternative Pricelists -->
        <b-card header="Alternative Operations"
                header-bg-variant="primary"
                header-text-variant="light"
                id="alternative_operations">

            <!-- Inputs -->
            <b-row class="mb-2">
                <!-- Market -->
                <b-col class="col-lg-1 pt-2">Market:</b-col>
                <b-select class="col-lg-5"
                          v-model="selectedCountry"
                          id="selectedCountry"
                          disabled>
                    <option :value="country"
                            v-if="getCurUser"
                            v-for="(country, index) in getCurUser.countries">{{ country.description }}</option>
                </b-select>
                <!-- Model -->
                <b-col class="col-lg-1 pt-2">Model:</b-col>
                <b-select class="col-lg-5"
                          v-model="selectedModel"
                          id="selectedModel"
                          disabled>
                    <template v-if="selectedCountry != null && selectedCountry.modelGroupItemList"
                              v-for="models in ((selectedCountry && selectedCountry.modelGroupItemList) ? selectedCountry.modelGroupItemList : [])">
                        <optgroup :label="models.label">
                            <option v-for="(model, index) in models.items"
                                    :key="index"
                                    :value="model">{{ model.label }}</option>
                        </optgroup>
                    </template>
                </b-select>
            </b-row>

            <!-- Buttons -->
            <b-row>
                <b-col class="col-lg-4"></b-col>
                <b-col class="col-lg-8">
                    <span class="float-right">
                        <b-button variant="primary" v-if="alternativePricelists.length < 1 "
                                  @click="insertMode()">Add</b-button>
                    </span>
                </b-col>
            </b-row>

            <!-- Table -->
            <template v-if="alternativePricelists.length > 0">
                <b-row>
                    <b-table striped
                             border
                             hover
                             responsive
                             :items="alternativePricelists"
                             :fields="alternativePricelistsFields"
                             class="mt-3">
                        <template v-slot:cell(keyCodopt)="data">
                            {{ data.item.keyCodopt }}
                        </template>

                        <template v-slot:cell(vetele)="data">
                            {{ data.item.vetele }}
                        </template>

                        <template v-slot:cell(isExcluded)="data">
                            <b-form-checkbox v-model="data.item.isExcluded"
                                             disabled></b-form-checkbox>
                        </template>

                        <template v-slot:cell(actions)="data">
                            <b-button size="sm"
                                      variant="primary mr-1"
                                      @click="modifyModeFromTable(data.item.keyCodopt, data.item.isExcluded)">Change</b-button>
                            <b-button size="sm"
                                      variant="primary mr-1"
                                      @click="deleteConfiguration(data.item.keyCodopt, data.item.isExcluded)">Delete</b-button>
                        </template>
                    </b-table>
                </b-row>
            </template>

            <!-- Empty Alternative Pricelists-->
            <template v-else>
                <b-row class="d-flex justify-content-center align-items-center my-2">
                    Empty Alternative Pricelist
                </b-row>
            </template>
                 <b-alert variant="warning" :show="true">
                    <i class="mdi mdi-alert-octagon"></i> {{ labels['priceconf.warning.alternative.pricelistDisc'] }}
                </b-alert>
        </b-card>

        <!-- Pricelist Operations -->
        <template v-if="isInsertMode">
            <b-card header="Pricelist Operations"
                    header-bg-variant="primary"
                    header-text-variant="light"
                    id="pricelist_operations">
                <b-card-text>
                    <!-- Inputs -->
                    <b-row>
                        <!-- Opt -->
                        <b-col class="col-lg-1 pt-2">Opt:</b-col>
                        <b-select :disabled="isModifyMode" class="col-lg-5"
                                  :class="{ 'red-border': selectedOpt === null }"
                                  v-model="selectedOpt"
                                  id="selectedOpt">
                            <template #first>
                                <option disabled
                                        value="null">{{ 'Select an Opt' }}</option>
                            </template>
                            <option :value="opt"
                                    v-if="getCurUser"
                                    v-for="(opt, index) in getOpts">{{ opt.code }}</option>
                        </b-select>


                        <!-- Excluded -->
                        <b-col class="col-lg-1"></b-col>
                        <b-col class="col-lg-1 pt-2 text-right">Excluded:</b-col>
                        <b-col class="col-lg-1"><input type="checkbox" :disabled="isModifyMode"
                                   v-model="isExcluded" /></b-col>
                    </b-row>

                    <!-- Buttons -->
                    <b-row class="mt-3">
                        <b-col class="col-lg-4"></b-col>
                        <b-col class="col-lg-8">
                            <span class="float-right">
                                <template v-if="isModifyMode">
                                    <b-button variant="primary mr-1"
                                              @click="saveConfiguration()">Save</b-button>
                                    <b-button variant="primary mr-1"
                                              @click="undoChanges()">Cancel</b-button>
                                </template>
                                <b-button v-if="!isModifyMode" variant="primary mr-1"
                                        @click="modifyMode()">Configure</b-button>
                            </span>
                        </b-col>
                    </b-row>
                </b-card-text>
            </b-card>
        </template>

        <!-- ISO Price Configurator -->
        <template v-if="isModifyMode">
            <!--Model Prices and Equipments-->
            <b-card header="Model Prices and Equipments"
                    header-bg-variant="primary"
                    header-text-variant="light"
                    id="prices_equipment"
                    :key="equipmentsTableKey"
                    class="mt-4">
                <b-card-text v-if="(selectedCountry && selectedModel) && optionalList && optionalList.length">
                    <!-- Opt base enabled -->
                    <fragment v-if="selectedCountry.enableBaseOpt">
                        <b-row>
                            <b-col class="col-lg-2 mr-1">Official base price of market:</b-col>
                            <b-col class="col-lg-2">Final base price (displayed to user):</b-col>
                        </b-row>
                        <b-row class="mt-1">
                            <input type="text"
                                   class="col-lg-2 mr-1"
                                   v-model="backupPrice" />
                            <span class="col-lg-2 pt-2">{{ (basePriceInfo) ? backupFormattedPrice : ''
                            }}</span>
                        </b-row>
                        <b-row class="mt-3 mb-3">
                            <b-col class="col-lg-12">
                                <span class="float-right">
                                    <b-button variant="primary mr-1"
                                              @click="rollbackInfo()"><i class="mdi mdi-rotate-left"></i>Rollback</b-button>
                                    <b-button variant="primary"
                                              v-if="true"
                                              @click="saveConfiguration();"><i class="mdi mdi-content-save"></i>Save
                                        Changes</b-button>
                                    <b-button variant="primary"
                                              v-else
                                              disabled><i class="mdi mdi-content-save"></i>Save Changes</b-button>
                                    <!--<i class="mdi mdi-loading mdi-spin mdi-18px ml-1"></i>
                <i class="mdi mdi-check mdi-18px ml-1 text-success"></i>
                <i class="mdi mdi-close mdi-18px ml-1 text-danger"></i>-->
                                </span>
                            </b-col>
                        </b-row>
                    </fragment>
                    <!-- Opt base disabled -->
                    <fragment v-else>
                        Official base price of market {{ (basePriceInfo) ? backupFormattedPrice : '' }}
                    </fragment>
                    <template>

                    </template>
                    <!-- table -->
                    <b-table id="equipmentsTable"
                             striped
                             border
                             hover
                             responsive
                             sticky-header="500px"
                             small
                             :items="optionalList"
                             :fields="filterFields"
                             :sort-by.sync="sortBy"
                             :sort-desc.sync="sortDesc"
                             primary-key="_id"
                             no-local-sorting
                             no-provider-paging
                             sort-icon-left
                             class="mt-3"
                             ref="equipmentsTable">

                        <template v-slot:cell(HiddenBYPR)="data"
                                  lang="html">
                            <b-row style="margin: 5px;">
                                <h4 v-if="data.item.isHiddenByPcm"
                                    class="panel-title"
                                    style="margin:auto;">
                                    <a class="col-lg-5 p-1 m-auto"
                                       size="sm"
                                       style="max-width: 2.875rem;"
                                       variant="primary"
                                       v-b-tooltip.hover
                                       title="Hidden By Product Catalog"
                                       @click="curItem = data.item; toggleOptStatus(data.item, false)">
                                        <i class="mdi mdi-eye-off-outline"
                                           style="display: block;"></i>
                                    </a>
                                </h4>
                            </b-row>
                        </template>
                        <!-- Custom row above header -->
                        <template v-slot:thead-top="data"
                                  lang="html">
                            <b-tr v-if="selectedCountry.enableBaseOpt">
                                <b-th
                                      :colspan="filterFields.length - optVisibleButtons + 2"></b-th><!-- 2 = bottoni rimossi -->
                                <b-th @click="mainListRollback('optionalList', 'defaultElementst.optionalList');"><b-button
                                              variant="secondary"><i class="mdi mdi-rotate-left"></i></b-button></b-th>
                                <b-th @click="importAllPrices('optionalList', 'msrp');"
                                      v-if="isPriceFromAS400"
                                      class="msrpPriceCol"><b-button variant="secondary">&lt;&lt;</b-button></b-th>
                            </b-tr>
                        </template>

                        <template v-slot:cell(officialPrice)="data"
                                  lang="html">
                            <input v-if="!data.item.isStandard"
                                   type="text"
                                   v-model="data.item.price"
                                   :class="getBorderStyle(data.item)" />
                            <div v-else> (is Standard) </div>
                        </template>
                        <!-- A custom formatted column -->
                        <template v-slot:cell(rollback)="data"
                                  lang="html">
                            <b-button variant="secondary"
                                      @click="curItem = data.item; rollbackMe(data.item, 'defaultElementst.optionalList')"><i
                                   class="mdi mdi-rotate-left"></i></b-button>
                        </template>

                        <template v-slot:cell(InfoComponent)="data"
                                  lang="html">
                            <b-button v-if="data.item.itemLastModInfo != 'No edit info' && selectedCountry.enableBaseOpt"
                                      class="col-lg-5 p-1 m-auto"
                                      size="sm"
                                      style="max-width: 2.875rem;"
                                      variant="primary"
                                      @click="openModalInfo(data.item.itemLastModInfo)">
                                <i class="mdi mdi-information-outline"
                                   style="display: block;"></i>
                            </b-button>
                        </template>

                        <template v-slot:cell(MsrpButton)="data"
                                  lang="html">
                            <b-button v-if="data.item.msrp"
                                      class="btn msrpPrice"
                                      variant="secondary"
                                      v-b-tooltip.hover
                                      :title="data.item.msrp"
                                      @click="priceMeTo(data.item, data.item.msrp)">
                                &lt; {{ data.item.msrp }}
                            </b-button>
                        </template>
                        <i class="mdi mdi-alert-octagon"></i>
                    </b-table>
                </b-card-text>
            </b-card>

            <!--FUORISERIE Model Prices and Equipments-->
            <b-card header="Fuoriserie Prices"
                    header-bg-variant="primary"
                    header-text-variant="light"
                    id="prices_fuoriserie"
                    class="mt-4">
                <b-card-text v-if="(selectedCountry && selectedModel) && fuoriserieList.length">
                    <fragment v-if="selectedCountry.enableBaseOpt">
                        <b-row class="mt-3 mb-3">
                            <b-col class="col-lg-12">
                                <span class="float-right">
                                    <b-button variant="primary"
                                              v-if="true"
                                              @click="saveConfiguration()"><i
                                           class="mdi mdi-content-save"></i>Save Changes</b-button>
                                    <b-button variant="primary"
                                              v-else
                                              disabled><i class="mdi mdi-content-save"></i>Save Changes</b-button>
                                    <!--<i class="mdi mdi-loading mdi-spin mdi-18px ml-1"></i>
                <i class="mdi mdi-check mdi-18px ml-1 text-success"></i>
                <i class="mdi mdi-close mdi-18px ml-1 text-danger"></i>-->
                                </span>
                            </b-col>
                        </b-row>
                    </fragment>
                    <fragment v-else>
                        Official base price of market {{ (basePriceInfo) ? backupFormattedPrice : '' }}
                    </fragment>
                    <template>
                    </template>
                    <b-table id="fuoriseriesTable"
                             striped
                             border
                             hover
                             responsive
                             sticky-header="500px"
                             small
                             :items="fuoriserieList"
                             :fields="specificVisibleFields('visibleToModelAndEq')"
                             :sort-by.sync="sortBy"
                             :sort-desc.sync="sortDesc"
                             primary-key="_id"
                             no-local-sorting
                             no-provider-paging
                             sort-icon-left
                             class="mt-3"
                             ref="fuoriseriesTable">

                        <template v-slot:cell(HiddenBYPR)="data"
                                  lang="html">
                            <b-row style="margin: 5px;">
                                <h4 v-if="data.item.isHiddenByPcm"
                                    class="panel-title"
                                    style="margin:auto;">
                                    <a class="col-lg-5 p-1 m-auto"
                                       size="sm"
                                       style="max-width: 2.875rem;"
                                       variant="primary"
                                       v-b-tooltip.hover
                                       title="Hidden By Product Catalog"
                                       @click="curItem = data.item; toggleOptStatus(data.item, false)">
                                        <i class="mdi mdi-eye-off-outline"
                                           style="display: block;"></i>
                                    </a>
                                </h4>
                            </b-row>
                        </template>

                        <template v-slot:cell(HideButton)="data"
                                  lang="html">
                            <b-row style="margin: 5px;"
                                   v-if="data.item.isHideEnabled"
                                   @click="curItem = data.item; toggleOptStatus(data.item, false)">
                                <input v-model="data.item.isHiddenByMarket"
                                       type="checkbox"
                                       v-b-tooltip.hover
                                       title="Hide Opt" />
                            </b-row>
                        </template>
                        <!-- Custom row above header -->
                        <template v-slot:thead-top="data"
                                  lang="html">
                            <b-tr v-if="selectedCountry.enableBaseOpt">
                                <b-th
                                      :colspan="specificVisibleFields('visibleToModelAndEq').length - optVisibleButtons"></b-th><!-- le colonne con i bottoni son sempre le ultime 2? -->
                                <b-th
                                      @click="mainListRollback('fuoriserieList', 'defaultElementst.fuoriserieList');"><b-button
                                              variant="secondary"><i class="mdi mdi-rotate-left"></i></b-button></b-th>
                                <b-th @click="importAllPrices('fuoriserieList', 'impPrice');"
                                      v-if="!isPriceFromAS400"
                                      class="impPriceCol"><b-button variant="secondary">&lt;&lt;</b-button></b-th>
                                <b-th @click="importAllPrices('fuoriserieList', 'mrpbtPrice');"
                                      v-if="!isPriceFromAS400"
                                      class="mrpbPriceCol"><b-button variant="secondary">&lt;&lt;</b-button></b-th>
                                <b-th @click="importAllPrices('fuoriserieList', 'msrp');"
                                      v-if="isPriceFromAS400"
                                      class="msrpPriceCol"><b-button variant="secondary">&lt;&lt;</b-button></b-th>
                            </b-tr>
                        </template>

                        <template v-slot:cell(officialPrice)="data"
                                  lang="html">
                            <input v-if="!data.item.isStandard"
                                   type="text"
                                   v-model="data.item.price"
                                   :class="getBorderStyle(data.item)" />
                            <div v-else> (is Standard) </div>
                        </template>
                        <!-- A custom formatted column -->
                        <template v-slot:cell(rollback)="data"
                                  lang="html">
                            <b-button variant="secondary"
                                      @click="curItem = data.item; rollbackMe(data.item, 'defaultElementst.fuoriserieList')"><i
                                   class="mdi mdi-rotate-left"></i></b-button>
                        </template>

                        <template v-slot:cell(InfoComponent)="data"
                                  lang="html">
                            <b-button v-if="data.item.itemLastModInfo != 'No edit info' && selectedCountry.enableBaseOpt"
                                      class="col-lg-5 p-1 m-auto"
                                      size="sm"
                                      style="max-width: 2.875rem;"
                                      variant="primary"
                                      @click="openModalInfo(data.item.itemLastModInfo)">
                                <i class="mdi mdi-information-outline"
                                   style="display: block;"></i>
                            </b-button>
                        </template>


                        <template v-slot:cell(ImpButton)="data"
                                  lang="html">
                            <b-button v-if="data.item.impPrice"
                                      class="btn impPriceCol"
                                      variant="secondary"
                                      v-b-tooltip.hover
                                      :title="data.item.impPrice"
                                      @click="priceMeTo(data.item, data.item.impPrice)">
                                &lt; {{ data.item.impPrice }}
                            </b-button>
                        </template>

                        <template v-slot:cell(MrpbtButton)="data"
                                  lang="html">
                            <b-button v-if="data.item.mrpbtPrice"
                                      class="btn mrpbPriceCol"
                                      variant="secondary"
                                      v-b-tooltip.hover
                                      :title="data.item.mrpbtPrice"
                                      @click="priceMeTo(data.item, data.item.mrpbtPrice)">
                                &lt; {{ data.item.mrpbtPrice }}
                            </b-button>
                        </template>

                        <template v-slot:cell(MsrpButton)="data"
                                  lang="html">
                            <b-button v-if="data.item.msrp"
                                      class="btn msrpPrice"
                                      variant="secondary"
                                      v-b-tooltip.hover
                                      :title="data.item.msrp"
                                      @click="priceMeTo(data.item, data.item.msrp)">
                                &lt; {{ data.item.msrp }}
                            </b-button>
                        </template>
                        <i class="mdi mdi-alert-octagon"></i>
                    </b-table>
                </b-card-text>
            </b-card>

            <!--customer programs-->
            <b-card header="Customer Programs"
                    header-bg-variant="primary"
                    header-text-variant="light"
                    id="customer_programs"
                    class="mt-4">
                <b-card-text
                             v-if="(selectedCountry && selectedModel) && selectedCountry.enableCustomerPrg && customerPrgList.length">
                    <b-row v-if="this.selectedCountry && this.selectedCountry.enableBaseOpt">
                        <b-col class="col-lg-12">
                            <span class="float-right">
                                <b-button variant="primary"
                                          v-if="true"
                                          @click="saveConfiguration()"><i
                                       class="mdi mdi-content-save"></i>Save Changes</b-button>
                                <b-button variant="primary"
                                          v-else
                                          disabled><i class="mdi mdi-content-save"></i>Save Changes</b-button>
                                <!--<i class="mdi mdi-loading mdi-spin mdi-18px ml-1"></i>
              <i class="mdi mdi-check mdi-18px ml-1 text-success"></i>
              <i class="mdi mdi-close mdi-18px ml-1 text-danger"></i>-->
                            </span>
                        </b-col>
                    </b-row>
                    <b-table id="custProgTable"
                             striped
                             border
                             hover
                             responsive
                             sticky-header="500px"
                             small
                             :items="customerPrgList"
                             :fields="specificVisibleFields('visibleToCustomPrg')"
                             :sort-by.sync="sortBy"
                             :sort-desc.sync="sortDesc"
                             primary-key="_id"
                             no-local-sorting
                             no-provider-paging
                             sort-icon-left
                             class="mt-3">
                        <!-- Custom row above header -->
                        <template v-slot:thead-top="data"
                                  lang="html"
                                  v-if="this.selectedCountry && this.selectedCountry.enableBaseOpt">
                            <b-tr>
                                <b-th :colspan="specificVisibleFields('visibleToCustomPrg').length - 1">
                                    <div style="min-height: 3vh;"></div>
                                </b-th><!-- le colonne con i bottoni son sempre le ultime 2? -->
                                <b-th
                                      @click="mainListRollback('customerPrgList', 'defaultElementst.customerPrgList');"><b-button
                                              variant="secondary"><i class="mdi mdi-rotate-left"></i></b-button></b-th>
                                <b-th></b-th>
                            </b-tr>
                        </template>

                        <template v-slot:cell(officialPrice)="data"
                                  lang="html">
                            <input v-if="!data.item.isStandard"
                                   type="text"
                                   v-model="data.item.price"
                                   :class="getBorderStyle(data.item)" />
                            <div v-else> (is Standard) </div>
                        </template>

                        <!-- A custom formatted column -->
                        <template v-slot:cell(rollback)="data"
                                  lang="html">
                            <b-button variant="secondary"
                                      @click="curItem = data.item; rollbackMe(data.item, 'defaultElementst.customerPrgList')"><i
                                   class="mdi mdi-rotate-left"></i></b-button>
                        </template>
                        <!-- TODO colonne custom per: hiddenProdCat, hidden, marketPrice, impPrice, mrpbtPrice -->
                    </b-table>
                </b-card-text>
            </b-card>

            <!--accessories-->
            <b-card header="Accessories"
                    header-bg-variant="primary"
                    header-text-variant="light"
                    id="accessories"
                    class="mt-4">
                <b-card-text v-if="(selectedCountry && selectedModel) && accessoriesList.length">
                    <b-row v-if="this.selectedCountry && this.selectedCountry.enableBaseOpt">
                        <b-col class="col-lg-12">
                            <span class="float-right">
                                <b-button variant="primary"
                                          v-if="true"
                                          @click="saveConfiguration()"><i
                                       class="mdi mdi-content-save"></i>Save Changes</b-button>
                                <b-button variant="primary"
                                          v-else
                                          disabled><i class="mdi mdi-content-save"></i>Save Changes</b-button>
                                <!--<i class="mdi mdi-loading mdi-spin mdi-18px ml-1"></i>
              <i class="mdi mdi-check mdi-18px ml-1 text-success"></i>
              <i class="mdi mdi-close mdi-18px ml-1 text-danger"></i>-->
                            </span>
                        </b-col>
                    </b-row>
                    <b-table id="accTable"
                             striped
                             border
                             hover
                             responsive
                             sticky-header="500px"
                             small
                             :items="accessoriesList"
                             :fields="specificVisibleFields('visibleToAcc')"
                             :sort-by.sync="sortBy"
                             :sort-desc.sync="sortDesc"
                             primary-key="_id"
                             no-local-sorting
                             no-provider-paging
                             sort-icon-left
                             class="mt-3">
                        <!-- Custom row above header -->
                        <template v-slot:thead-top="data"
                                  lang="html"
                                  v-if="this.selectedCountry && this.selectedCountry.enableBaseOpt">
                            <b-tr>
                                <b-th :colspan="specificVisibleFields('visibleToAcc').length - accVisibleButtons">
                                    <div style="min-height: 3vh;"></div>
                                </b-th><!-- le colonne con i bottoni son sempre le ultime 2? -->
                                <b-th
                                      @click="mainListRollback('accessoriesList', 'defaultElementst.accessoriesList');"><b-button
                                              variant="secondary"><i class="mdi mdi-rotate-left"></i></b-button></b-th>
                                <b-th @click="importAllPrices('accessoriesList', 'msrp');"
                                      v-if="isPriceFromAS400"
                                      class="msrpPriceCol"><b-button variant="secondary">&lt;&lt;</b-button></b-th>
                                <b-th></b-th>
                            </b-tr>
                        </template>

                        <template v-slot:cell(officialPrice)="data"
                                  lang="html">
                            <input v-if="!data.item.isStandard"
                                   type="text"
                                   v-model="data.item.price"
                                   :class="getBorderStyle(data.item)" />
                            <div v-else> (is Standard) </div>
                        </template>

                        <!-- A custom formatted column -->
                        <template v-slot:cell(rollback)="data"
                                  lang="html">
                            <b-button variant="secondary"
                                      @click="curItem = data.item; rollbackMe(data.item, 'defaultElementst.accessoriesList')"><i
                                   class="mdi mdi-rotate-left"></i></b-button>
                        </template>
                        <!-- TODO colonne custom per: hiddenProdCat, hidden, marketPrice, impPrice, mrpbtPrice -->
                        <template v-slot:cell(MsrpButton)="data"
                                  lang="html">
                            <b-button v-if="data.item.msrp"
                                      class="btn msrpPrice"
                                      variant="secondary"
                                      v-b-tooltip.hover
                                      :title="data.item.msrp"
                                      @click="priceMeTo(data.item, data.item.msrp)">
                                &lt; {{ data.item.msrp }}
                            </b-button>
                        </template>
                    </b-table>
                </b-card-text>
            </b-card>
        </template>
    </section>
</template>

<script>
import mixin from '../../mixin/mixin.js'

export default {
    name: "PriceConfiguratorException",
    mixin: [mixin],
    props: [
        'selectedCountry',
        'selectedModel',
        'optionalList',
        'basePriceInfo',
        'isPriceFromAS400',
        'activePricemask',
        'activeCurrency',
        'sortBy',
        'sortDesc',
        'equipmentsTableKey',
        'labels',
        'specificVisibleFields',
        'optVisibleButtons',
        'fuoriserieList',
        'getCurUser',
        'customerPrgList',
        'accessoriesList',
        'isFromSol',
        'isFromCampaign',
        'accVisibleButtons',
        'authHeader',
        'backupData'
    ],
    data() {
        return {
            selectedOpt: null,
            isExcluded: false,
            isInsertMode: false,
            isModifyMode: false,
            alternativePricelists: [],
            alternativePricelistsFields: [
                { key: 'keyCodopt', label: 'Code' },
                { key: 'vetele', label: 'Model' },
                { key: 'isExcluded', label: 'Excluded' },
                { key: 'actions', label: 'Actions' }
            ],
            //MOCK
            mockFuoriserieLists: null,
            backupPrice: this.basePriceInfo.price,
            backupFormattedPrice: null
        }
    },
    mounted() {
        this.getAlternativePricelists();
    },
    computed: {
        filterFields() {
            const fieldsExcluded = [
                'HideButton',
                'ImpButton',
                'MrpbtButton'
            ]
            const fieldsTmp = this.specificVisibleFields('visibleToModelAndEq');
            return fieldsTmp.filter((field) => !fieldsExcluded.includes(field.key));
        },
        getOpts() {
            return [...this.optionalList, ...this.fuoriserieList]
        }
    },
    methods: {
        setPriceTo(propName, price) {
            this.$emit('setPriceTo', propName, price);
        },
        rollbackInfo() {
            this.$emit('rollbackInfo');
        },
        showAlert(data) {
            this.$emit('showAlert', data);
        },
        mainListRollback(mainList, listName) {
            this.$emit('mainListRollback', mainList, listName);
        },
        importAllPrices(mainList, target) {
            this.$emit('importAllPrices', mainList, target);
        },
        getBorderStyle(item) {
            this.$emit('getBorderStyle', item);
        },
        rollbackMe(item, ssName) {
            this.$emit('rollbackMe', item, ssName);
        },
        openModalInfo(message) {
            this.$emit('openModalInfo', message);
        },
        priceMeTo(target, price) {
            this.$emit('priceMeTo', target, price);
        },
        getModelBasePriceInfo(spinner) {
            this.$emit('getModelBasePriceInfo', spinner);
        },
        setSpinnerStatus(value) {
            this.$emit('setSpinnerStatus', value);
        },
        updateBackupData() {
            this.$emit('updateBackupData');
        },
        restoreBackup() {
            this.$emit('restoreBackup');
        },
        closeModal() {
            this.$emit('closeModal');
        },
        getAlternativePricelists() {
            this.setSpinnerStatus(true);
            const url = `/ccb/auth/fe/priceConf/alternativePriceLists/${this.selectedCountry.id}/${this.selectedModel.value}`
            this.axios
                .get(url,
                    {
                        params: null,
                        ...this.authHeader
                    })
                .then((res) => {
                    this.setSpinnerStatus(false)
                    
                    //MOCK: this.alternativePricelists = [{ "vetele": "8578600", "codmercato": "I", "keyCodopt": "KNAV", "isExcluded": false }, { "vetele": "8578600", "codmercato": "I", "keyCodopt": "Q2XY", "isExcluded": false }]
                    this.alternativePricelists = res.data
                }).catch((err) => {

                })
        },
        formattaPrezzoStringa(currency, numeroStringa) {

            if(numeroStringa == null || numeroStringa == "") {
                return " "
            }

            numeroStringa = numeroStringa.toString();

            const separatoreMigliaia = ".";

            const [parteInteri, parteDecimali] = numeroStringa.split(".");
            const parteInteraFormattata = parteInteri.replace(/\B(?=(\d{3})+(?!\d))/g, separatoreMigliaia);
            const prezzoFormattato = parteDecimali ? `${parteInteraFormattata}.${parteDecimali}` : parteInteraFormattata;

            return `${currency} ${prezzoFormattato}`;
        },
        getAllAlternativeListPrices() {
            this.setSpinnerStatus(true);
            const url = `/ccb/auth/fe/priceConf/detailsExceptionByModelVersion/${this.selectedCountry.id}/${this.selectedModel.value}/${this.selectedOpt.code}/${this.isExcluded}`
            this.axios
                .get(url,
                    {
                        params: null,
                        ...this.authHeader
                    })
                .then((res) => {
                    this.setSpinnerStatus(false)
                    let prices = res.data;
                    prices.forEach(price_opt_row => {

                        let cod_opt = price_opt_row[0]
                        let price = price_opt_row[1]
                        let isFound = false;

                        if(cod_opt == '-') {
                            this.backupPrice = price;
                            this.backupFormattedPrice = this.formattaPrezzoStringa(this.basePriceInfo.currency, price);
                            isFound = true;
                        }

                        for (let i = 0; i < this.optionalList.length; i++) {
                            if (this.optionalList[i].code == cod_opt) {
                                this.optionalList[i].price = price;
                                isFound = true;
                                break;
                            }
                        }

                        if(!isFound){
                            console.error("opt not found: " + cod_opt);
                        }
                    });
                    
                }).catch((err) => {
                    console.error(err);
                })
        },
        replacePriceValue(jsonArray, searchString) {

            return "Stringa non trovata.";
        },
        saveConfiguration() {
            this.setSpinnerStatus(true);
            let basePriceBackup = this.basePriceInfo;
            basePriceBackup.price = this.backupPrice;
            const url = `/ccb/auth/fe/priceConf/saveSniMarketDataModelAndOpt/${this.selectedCountry.id}/${this.selectedModel.value}/${this.selectedOpt.code}/${this.isExcluded}`
            const marketDataModel = {
                currency: this.activeCurrency, //campo "Price Format" rimosso
                pricemask: this.activePricemask, //campo "Visible" rimosso
                userModis: this.getCurUser.idUser, //user id                
                optList: this.optionalList, //Model Prices and Equipments 
                basePrice: basePriceBackup, //Model Prices and Equipments
                customerPrgList: this.customerPrgList, //customer programs                
                accList: this.accessoriesList, //accessories              
            }

            this.axios
                .put(url, marketDataModel, this.authHeader)
                .then(response => {
                    if (response.status == 200) {
                        this.$bvModal.msgBoxOk(response.data.message, {
                            okVariant: 'success',
                            hideHeaderClose: false,
                            centered: true
                        })
                    }
                }
                ).then((result) => {
                    this.setSpinnerStatus(false);
                    this.getModelBasePriceInfo(true);
                    this.isModifyMode = false
                    this.isInsertMode = false
                    this.getAlternativePricelists();
                }).catch((error) => {
                });
        },
        insertMode() {
            if(this.isModifyMode){
                this.setSpinnerStatus(false);
                this.getModelBasePriceInfo(true);
                this.isModifyMode = false
                this.isInsertMode = false
                this.getAlternativePricelists();
                this.backupPrice = this.basePriceInfo.price;
                this.backupFormattedPrice = this.formattaPrezzoStringa(this.basePriceInfo.currency, this.basePriceInfo.price);
            }
            this.isInsertMode = true
        },
        modifyMode() {
            this.isModifyMode = true;
            this.updateBackupData()
        },
        modifyModeFromTable(keyOpt, isExcluded) {
            this.isInsertMode = true
            this.modifyMode()
            this.isExcluded = isExcluded
            this.selectedOpt = this.getOpts.find((opt) => opt.code === keyOpt);
            this.getAllAlternativeListPrices();
        },
        undoChanges() {
            this.isModifyMode = false;
            this.isInsertMode = false;
            this.selectedOpt = null
            this.restoreBackup()
        },
        deleteConfiguration(keyOpt, isExcluded) {
            this.setSpinnerStatus(true);
            const url = `/ccb/auth/fe/priceConf/deleteAlternativePriceLists/${this.selectedCountry.id}/${this.selectedModel.value}/${keyOpt}/${isExcluded}`

            this.axios
                .delete(url, { ...this.authHeader })
                .then((res) => {
                    this.setSpinnerStatus(false);
                    this.undoChanges()
                    this.getAlternativePricelists();
                })
                .catch(error => {
                })
        },
        //MOCK
        mockFuoriserie(numOfElements) {
            const sampleObject = {
                serialVersionUID: '2271806600986195885L',
                pargroup: '',
                isStandard: false,
                impPrice: this.bigDecimal(0),
                mrpbtPrice: this.bigDecimal(0),
                dateIns: new Date(),
                dateMod: new Date(),
                isHiddenByPcm: null,
                isHiddenByMarket: null,
                hiddenByMarketLastDateMod: new Date(),
                hiddenByMarketLastIdUserMod: '',
                priceLastDateMod: new Date(),
                priceLastIdUserMod: '',
                lastPrice: this.bigDecimal(0),
                msrp: '',
                isFuoriserie: true
            };

            const objectsArray = [];
            for (let i = 0; i < numOfElements; i++) {
                objectsArray.push({ ...sampleObject, pargroup: 'Group' + i });
            }

            return objectsArray;
        },

        bigDecimal(value) {
            this.value = value;
            this.toString = function () {
                return this.value.toString();
            };
        }
    }
}
</script>

<style>
.red-border {
    border: 1px solid red;
}
</style>